// Shared constants + tiny helpers for the patient-file tabs.

export const ROLE_LABELS = {
  care_coordinator: 'Care Coordinator',
  clinician: 'Clinician',
  // Legacy aliases — kept so historical task rows still render a label until backfilled.
  md: 'Clinician', rn: 'Clinician', np: 'Clinician', pharmacist: 'Clinician', care_team: 'Clinician',
  operations: 'Care Coordinator', admin: 'Care Coordinator', ops: 'Care Coordinator', operator: 'Care Coordinator',
};

// Canonical reader lives in logic/task.ts (also consumed by logic/taskCascade).
export { templateCodeOf } from '../../../logic/task';

export const ALIGNMENT_BLOCKING_ONB_CODES = new Set([
  'onb_eligibility_check',
  'onb_clinical_exclusion_screen',
  'onb_consent_verify',
]);

// rpt_*_submission template_code → WF37 report_kind. A quarter is one filing (BP, weight, BMI) from
// one task; the retired weight task maps too, for rows still open until WF10 cancels them.
export const REPORTING_KIND_BY_TEMPLATE = {
  'rpt_baseline_submission':         'baseline',
  'rpt_quarterly_bp_submission':     'quarterly',
  'rpt_quarterly_weight_submission': 'quarterly',
  'rpt_final_submission':            'final',
};

// Templates whose active card deep-links to the Elation chart instead of an
// in-app action. onb_baseline_labs_order: WF6 already placed the draft order —
// link to e-sign it, not the "Order in Elation" button (would fire WF31 twice).
export const ELATION_DEEPLINK_TEMPLATES = new Set([
  'rec_monthly_claims',
  'onb_care_plan_share',
  'onb_baseline_labs_order',
]);
